module.exports = __webpack_public_path__ + "static/ui-1-92b4ef678050beb0f2f6e987b2bedd60.png";